import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { InputComponent } from '../input/input';

/** Naira-prefixed amount input — thin composition over `InputComponent`'s existing amount formatting (SCRUM-1228). */
@Component({
  selector: 'lib-money-input',
  imports: [ReactiveFormsModule, InputComponent],
  templateUrl: './money-input.html',
})
export class MoneyInput {
  @Input({ alias: 'control' }) control!: FormControl;
  @Input({ alias: 'label' }) label: string = '';
  @Input({ alias: 'secondaryLabel' }) secondaryLabel: string = '';
  @Input({ alias: 'placeholder' }) placeholder: string = 'Input amount';
  @Input({ alias: 'id' }) id: string = '';
  @Input({ alias: 'errorMessage' }) errorMessage?: string;
  @Input({ alias: 'inputClass' }) inputClass: string = '';
  @Input({ alias: 'labelClass' }) labelClass: string = '';
}
